import {Component, Input, OnInit, ViewChild, TemplateRef} from '@angular/core';
import {InventoryComponent} from "@irb/irb-orders/order-blotter/inventory/inventory.component";
import {InventoryService} from "@irb/irb-orders/order-blotter/inventory/inventory.service";
import {UIDropDownBlotter} from "@irb/irb-editors/edit-trading-instructions/trade-instructions/trade-instructions.model";
import {IDropdownItem} from "@irb-common/models/dropdown.model";
import {formatFeesOptions} from "@irb-common/formatters";
import {DropdownFilterComponent} from "@irb-common/components/dropdown-filter/dropdown-filter.component";
import { AppService } from '@irb/app.service';
import { IrbAppEvents } from '@irb-common/events';
import { IAlertDialogData } from '@irb/app.model';

@Component({ standalone: false,
  selector: 'irb-reinvestment-trade',
  templateUrl: './reinvestment-trade.component.html',
  styleUrls: ['./reinvestment-trade.component.scss']
})
export class ReinvestmentTradeComponent implements OnInit {
  @ViewChild('reinvestUnsupportedConfigMessage') reinvestUnsupportedConfigMessage: TemplateRef<any>;
  @ViewChild('feeElem')
  feeElem: any;
  @Input()
  parentObj: InventoryComponent;
  @Input()
  data: any;
  @Input()
  actionType: string = '';
  multiRecords: any[];

  pfs: InventoryService;
  reinvestmentDividends = false;
  reinvestmentCapitalGains= false;
  feeSelected: UIDropDownBlotter;
  isAllMutualFund = false;
  isFeeVarious = false;
  sharesPresent = false;
  isShowReinvestmentDividendsVarious = false;
  isShowReinvestmentCapitalGainsVarious = false;
  constructor(private as: AppService) { }

  ngOnInit(): void {
    if (this.parentObj) {
      this.pfs = this.parentObj.pfs;
    }
    if (this.data) {
      if (this.actionType === 'MultiEdit') {
        this.multiRecords = this.data;
        this.data = this.data[0];
        this.isAllMutualFund = true;
        this.isFeeVarious = false;
        this.multiRecords.forEach(record => {
          if (record.securityType !== 'Mutual Fund' ) {
            this.isAllMutualFund = false;
            this.isFeeVarious = true;
          } else {
            if (record.feesOption !== this.data.feesOption) {
              this.isFeeVarious = true;
            }
            if (record.amountType === 'Shares') {
              this.sharesPresent = true;
            }
            if (record.isDividendReinvest !== this.data.isDividendReinvest) {
              this.isShowReinvestmentDividendsVarious = true;
            }
            if (record.isCapGainsReinvest !== this.data.isCapGainsReinvest) {
              this.isShowReinvestmentCapitalGainsVarious = true;
            }
          }
        });
      } else {
        if (this.data.securityType === 'Mutual Fund' ) {
          this.isAllMutualFund = true;
        }
        if (this.data.amountType === 'Shares') {
          this.sharesPresent = true;
        }
      }
      this.reinvestmentDividends = this.isShowReinvestmentDividendsVarious ? null: (this.data.isDividendReinvest || false);
      this.reinvestmentCapitalGains = this.isShowReinvestmentCapitalGainsVarious ? null: (this.data.isCapGainsReinvest || false);
      this.feeSelected = !this.isFeeVarious ? {name: formatFeesOptions(this.data.feesOption), id: this.data.feesOption, value: this.data.feesOption} : null;
    }

  }

  reinvestmentDividendsChanged(event: any) {
    false && console.log(event);
    this.reinvestmentDividends = !this.reinvestmentDividends;
    
    this.validateReinvestChange(() => {
      if (this.pfs) {
        this.pfs.updateOrderPayload.data.reinvestmentDividends = this.reinvestmentDividends;
        this.pfs.updateOrderPayload.data.reinvestmentCapitalGains = this.reinvestmentCapitalGains;
        this.pfs.updateOrderPayload.isModified = true;
      }
    });
  }

  reinvestmentCapitalGainsChanged(event: any) {
    false && console.log(event);
    this.reinvestmentCapitalGains = !this.reinvestmentCapitalGains;
    
    this.validateReinvestChange(() => {
      if (this.pfs) {
        this.pfs.updateOrderPayload.data.reinvestmentDividends = this.reinvestmentDividends;
        this.pfs.updateOrderPayload.data.reinvestmentCapitalGains = this.reinvestmentCapitalGains;
        this.pfs.updateOrderPayload.isModified = true;
      }
    });
  }

  validateReinvestChange(cb: Function) {
    const isReinvestValid = !((this.reinvestmentDividends === true || this.isShowReinvestmentDividendsVarious === true )
      && (this.reinvestmentCapitalGains === false || this.isShowReinvestmentCapitalGainsVarious === true));
        
    if(!isReinvestValid) {
      this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
        msg: "You have selected an unsupported reinvestment election.",
        altMsgTemplate: this.reinvestUnsupportedConfigMessage,
        dType: "WARN"
      } as IAlertDialogData);

      setTimeout(() => {
        this.isShowReinvestmentCapitalGainsVarious = false;
        this.reinvestmentCapitalGains = true;      
        cb();
      });
    } else {
      cb();
    }
  }

  getFee(searchStr: any) {
    const v: Array<IDropdownItem> = [];
    v.push({name: 'Include', value: 'INCLUDE'});
    v.push({name: 'Add', value: 'ADD'});
    const f = DropdownFilterComponent.getFilteredList(searchStr, v);
    this.feeElem.set(f);
  }
  feesOptionChanged() {
    this.feeElem.value = this.feeSelected;
    this.pfs.updateOrderPayload.data.feesOption = this.feeSelected.value;
    this.pfs.updateOrderPayload.isModified = true;

  }
  dividendsVariousClicked() {
    this.isShowReinvestmentDividendsVarious = false;
    this.pfs.updateOrderPayload.prevData.reinvestmentDividends = null;
    this.reinvestmentDividendsChanged(null);
  }
  capitalGainsVariousClicked() {
    this.isShowReinvestmentCapitalGainsVarious = false;
    this.pfs.updateOrderPayload.prevData.reinvestmentCapitalGains = null;
    this.reinvestmentCapitalGainsChanged(null);
  }
}
